import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Row, Col } from "react-flexbox-grid";
import { MdDashboard } from "react-icons/md";
import { FiCalendar } from "react-icons/fi";
import { AiOutlineTag, AiOutlineSetting } from "react-icons/ai";
import { getAppUser } from "../actions/user-actions";
import ReactTooltip from "react-tooltip";
import styles from "../styles/components/sidebar.module.scss";
// Adding icons to disable and enable sidebar
import { MdClose } from "react-icons/md";
import { IoMdHelp } from "react-icons/io";
import { Menu } from "react-feather";
import { NavLink } from "react-router-dom";
import { getAllEvents } from "../actions/events-actions";

export class Sidebar extends Component {
  state = {
    btn_view: localStorage.getItem("menu")
  };

  componentDidUpdate(prevProps) {
    if (this.props.logOutSuccess && !prevProps.logOutSuccess) {
      window.location.href = "/";
      localStorage.clear();
    }
  }

  fetchData = (prevlocation, nextLocation) => {
    if (prevlocation !== nextLocation){
      this.props.getAppUser()
      this.forceUpdate()
    }
  };

  openFAQs = () => {
    window.open('https://liveliplanner.com/faqs/', '_blank');
  }

  render() {
    return (
      <div
        className={[
          styles.__divStyle,
          this.props.show ? styles.__active : styles.__hidden
        ].join(" ")}
      >
        <Row
          start={this.props.show ? "xs" : null}
          center={!this.props.show ? "xs" : null}
        >
          <Col xs={12}>
            <Row
              end={this.props.show ? "xs" : null}
              center={!this.props.show ? "xs" : null}
              className={this.props.show ? styles.__edge__menu : ""}
            >
              <Col xs={12} style={{ padding: "0" }}>
                <button
                  className={[this.props.menuStyle, 'world'].join(' ')}
                  onClick={this.props.toggleSideBar}
                >
                  {this.props.show ? (
                    <MdClose
                      size="28"
                      color={"white"}
                      style={{
                        marginLeft: "auto",
                        marginRight: "auto"
                      }}
                    />
                  ) : (
                    <Menu
                      size="28"
                      color="white"
                      style={{
                        marginLeft: "auto",
                        marginRight: "auto"
                      }}
                    />
                  )}
                </button>
              </Col>
            </Row>
          </Col>
          {this.props.isAdmin && (
            <Col xs={12} className={styles.__btn_options}>
              <NavLink style={{textDecoration: "none"}} to="/dashboard" activeClassName={styles.active_link}>
                <button
                  data-tip={!this.props.show ? "Dashboard" : null}
                  data-for="dashboard"
                  className={styles.__btn_dashboard}
                >
                  <div className={styles.__icon}>
                    {" "}
                    <MdDashboard size="22" color={"#68D2DF"} />
                  </div>
                  <span className={styles.__btn_name}>Dashboard</span>
                  <ReactTooltip type="info" id="dashboard"/>
                </button>
              </NavLink>
            </Col>
          )}
          <Col xs={12} className={styles.__btn_options}>
            <NavLink style={{textDecoration: "none"}}
              to="/calendar"
              activeClassName={styles.active_link}
              onClick={() => {this.fetchData(window.location.pathname, '/main/calendar')}}
            >
              <button
                data-tip={!this.props.show ? "Calendar" : null}
                data-for="calendar"
                className={[styles.__btn_dashboard, 'step10-calendar'].join(' ')}
              >
                <div className={styles.__icon}>
                  {" "}
                  <FiCalendar size="22" color={"#68D2DF"} />
                </div>
                <span className={styles.__btn_name}>Calendar</span>
                <ReactTooltip type="info" id="calendar"/>
              </button>
            </NavLink>
          </Col>
          <Col xs={12} className={styles.__btn_options}>
            <NavLink style={{textDecoration: "none"}} to="/tickers" activeClassName={styles.active_link}>
              <button
                data-tip={!this.props.show ? "Tickers" : null}
                data-for="tickers"
                className={[styles.__btn_dashboard, 'step5-tickersPage'].join(' ')}
              >
                <div className={styles.__icon}>
                  {" "}
                  <AiOutlineTag size="22" color={"#68D2DF"} />
                </div>
                <span className={styles.__btn_name}>Calendar tickers</span>
                <ReactTooltip type="info" id="tickers"/>
              </button>
            </NavLink>
          </Col>
          <Col xs={12} className={styles.__btn_options}>
            <NavLink style={{textDecoration: "none"}} to="/settings" activeClassName={styles.active_link}>
              <button
                data-tip={!this.props.show ? "Settings" : null}
                data-for="settings"
                className={[styles.__btn_dashboard, 'step1-settingPage'].join(' ')}
              >
                <div className={styles.__icon}>
                  {" "}
                  <AiOutlineSetting size="22" color={"#68D2DF"} />
                </div>
                <span className={styles.__btn_name}>Settings</span>
                <ReactTooltip type="info" id="settings"/>
              </button>
            </NavLink>
          </Col>
          <Col xs={12} className={[styles.__btn_options, styles.__FAQs, 'step15-calendar'].join(' ')}>
            <button data-tip={!this.props.show ? "FAQs" : null} className={styles.__btn_FAQs} 
              onClick={() => this.openFAQs()} data-for="FAQ">
              { this.props.show && <div> <IoMdHelp size="22" color={"#FFF"} className={styles.__icon} /> </div> }
              <span className={styles.__btn_name_FAQ}> FAQs </span>
              <ReactTooltip type="info" id="FAQ" />
            </button>
          </Col>
        </Row>
      </div>
    );
  }
}

Sidebar.propTypes = {
  logOut: PropTypes.func,
  loading: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    loading: state.userReducer.loading,
    defaultDate: state.userReducer.defaultDate
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAllEvents: sort => dispatch(getAllEvents(sort)),
    getAppUser: () => dispatch(getAppUser())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
